// extracted by mini-css-extract-plugin
export default {"admin-button":"administration_admin-button__ZMfDP","admin-button__icon":"administration_admin-button__icon__6PmXK","admin-button__text":"administration_admin-button__text__Pt3by"};